import type { ViewConfigRow } from '@streamlain/view-config';

/**
 * Option metadata for `EnumSelect`. `labelKey` is an i18n resource key
 * resolved by the consuming section via `useI18n()` at render time —
 * keeping the constants module-init safe (no React hook needed here).
 */
export interface Option<T extends string> {
  value: T;
  labelKey: string;
}

export const LAYOUT_OPTIONS: ReadonlyArray<
  Option<ViewConfigRow['layoutType']>
> = [
  {
    value: 'list',
    labelKey: 'com.streamlain.customApps.viewConfig.layout.opt.list',
  },
  {
    value: 'grid',
    labelKey: 'com.streamlain.customApps.viewConfig.layout.opt.grid',
  },
  {
    value: 'kanban',
    labelKey: 'com.streamlain.customApps.viewConfig.layout.opt.kanban',
  },
  {
    value: 'dashboard',
    labelKey: 'com.streamlain.customApps.viewConfig.layout.opt.dashboard',
  },
];

export const ENTRY_STYLE_OPTIONS: ReadonlyArray<
  Option<ViewConfigRow['entryStyle']>
> = [
  {
    value: 'plain',
    labelKey: 'com.streamlain.customApps.viewConfig.entryStyle.opt.plain',
  },
  {
    value: 'card',
    labelKey: 'com.streamlain.customApps.viewConfig.entryStyle.opt.card',
  },
  {
    value: 'image-card',
    labelKey: 'com.streamlain.customApps.viewConfig.entryStyle.opt.imageCard',
  },
  {
    value: 'hero-card',
    labelKey: 'com.streamlain.customApps.viewConfig.entryStyle.opt.heroCard',
  },
];

export const NAV_OPTIONS: ReadonlyArray<Option<ViewConfigRow['nav']>> = [
  {
    value: 'none',
    labelKey: 'com.streamlain.customApps.viewConfig.nav.opt.none',
  },
  {
    value: 'top',
    labelKey: 'com.streamlain.customApps.viewConfig.nav.opt.top',
  },
  {
    value: 'sidebar',
    labelKey: 'com.streamlain.customApps.viewConfig.nav.opt.sidebar',
  },
  {
    value: 'both',
    labelKey: 'com.streamlain.customApps.viewConfig.nav.opt.both',
  },
];

export const PAGINATION_OPTIONS: ReadonlyArray<
  Option<ViewConfigRow['pagination']>
> = [
  {
    value: 'none',
    labelKey: 'com.streamlain.customApps.viewConfig.pagination.opt.none',
  },
  {
    value: 'numbered',
    labelKey: 'com.streamlain.customApps.viewConfig.pagination.opt.numbered',
  },
  {
    value: 'infinite',
    labelKey: 'com.streamlain.customApps.viewConfig.pagination.opt.infinite',
  },
];

export const ROW_DETAIL_OPTIONS: ReadonlyArray<
  Option<ViewConfigRow['rowDetailMode']>
> = [
  {
    value: 'none',
    labelKey: 'com.streamlain.customApps.viewConfig.rowDetail.opt.none',
  },
  {
    value: 'page',
    labelKey: 'com.streamlain.customApps.viewConfig.rowDetail.opt.page',
  },
  {
    value: 'modal',
    labelKey: 'com.streamlain.customApps.viewConfig.rowDetail.opt.modal',
  },
];
